<template>
	<div class="tip-text">
		<dc-icon
			icon="lightbulb"
			size="2x"
			class="tip-icon has-text-dailycare"
		/>
		<slot></slot>
	</div>
</template>
<script>
export default {};
</script>

<style lang="scss" scoped>
@import "~@/scss/settings";

.tip-icon {
	margin-bottom: 0.75em;
}

.tip-text {
	border: 1px solid #ccc;
	padding: 1em;
	position: relative;
	border-radius: $radius-large;
	background-color: #fff;
}
</style>
